import React from "react";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PeopleIcon from '@material-ui/icons/People';
import { Grid, Paper } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles({
    container: { 
        padding: '10px',
        minHeight: '150px' 
    }
});


const Contadores = (props) => {

    const classes = useStyles();

    return(<>
        <Grid container spacing={2} >
            <Grid item xs={3} >
                <Paper elevation={2} className={classes.container}>
                    <PeopleIcon /><br />
                    <span style={{ fontSize: '30px' }}>{ props.viewersCount }</span><br />
                    <span>Espectadores Actuales</span><br />
                </Paper>
              
            </Grid>
            <Grid item xs={3}>
                <Paper elevation={2} className={classes.container}>
                    <ChatBubbleOutlineIcon /><br />
                    <span style={{ fontSize: '30px' }}>{props.conversationCount}</span><br />
                    <span>Mensajes Totales</span><br />
                </Paper>
            </Grid>
            <Grid item xs={3}>
                <Paper elevation={2} className={classes.container}>
                    <FavoriteIcon /><br />
                    <span style={{ fontSize: '30px' }}>{props.reactionCount}</span><br />
                    <span>Reacciones</span><br />
                </Paper>
                
            </Grid>
            <Grid item xs={3}>
                <Paper elevation={2} className={classes.container}>
                    < AccessTimeIcon /><br />
                    <span style={{ fontSize: '30px' }}>0m</span><br />
                    <span>Tiempo Promedio</span><br />
                </Paper>
                
            </Grid>
        </Grid>
    </>)

}

export default Contadores;